import React from 'react';
import ResultCard32 from '../resultCard32/ResultCard32';

/**
 * 32 Cards B (card32eu) "Last Result" items — same reference markup as 32 Cards A;
 * the result modal adds the card32eu description rows (Odd/Even, Black/Red, Total, Single).
 */
const ResultCard32B = (props) => <ResultCard32 gameType="card32eu" {...props} />;

export default ResultCard32B;
